import type { BaseHit, Hit } from 'instantsearch.js'
import {
  Highlight,
  type HighlightProps,
  Snippet,
  type SnippetProps
} from 'react-instantsearch'
import { l } from './algoliaLocalization'

function useTranslatedAttribute(
  attribute: unknown,
  hit: Hit<BaseHit>
): [string, unknown | undefined] {
  const parts = String(attribute).split('.')
  let value = hit as Record<string, unknown>
  for (const part of parts) {
    if (!value || !(value instanceof Object)) return ['', undefined]
    value = value[part] as Record<string, unknown>
  }
  const locale = l(value, { fallback: 'none' })
  return [`${String(attribute)}.${locale}`, value[locale]]
}

export function TranslatedHighlight<THit extends Hit<BaseHit>>(
  props: HighlightProps<THit>
) {
  const [key, value] = useTranslatedAttribute(props.attribute, props.hit)
  return value ? <Highlight {...props} attribute={key} /> : null
}

export function TranslatedSnippet<THit extends Hit<BaseHit>>(
  props: SnippetProps<THit>
) {
  const [key, value] = useTranslatedAttribute(props.attribute, props.hit)
  return value ? <Snippet {...props} attribute={key} /> : null
}
